import React from 'react';
import {
    LOAD_GUESTS,
    SET_ACTIVE_STEP,
    SET_ACTIVE_GUEST,
    SET_STEPS,
    ADD_GUEST_DOCUMENT,
    REMOVE_GUEST_DOCUMENT,
    UPDATE_GUEST_FORM, UPDATE_GUEST
} from '../actions/types';
import {produce} from 'immer';
import guestFormData from '~/services/adapters/guest';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

const defaultSteps = {

    personal_details: {
        label: <TextTranslate name="form-personal-details" fallback="Personal Details"/>
    },
    special_requirements: {
        label: <TextTranslate name="form-special-requirements" fallback="Special Requirements"/>
    },
    hotel_rooms: {
        label: <TextTranslate name="form-hotel-rooms" fallback="Hotel Rooms"/>
    },
    travel: {
        label: <TextTranslate name="form-travel" fallback='Flights & Travel'/>
    },
    emergency_contact: {
        label: <TextTranslate name="form-emergency-contact" fallback='Emergency Contact'/>
    },
    documents: {
        label: <TextTranslate name="form-documents" fallback='Documents'/>
    }
};

const initialState = {
    list: null,
    activeGuest: null,
    activeStep: {},
    formData: {},
    loaded: false,
    subGuestExcludedSteps: ['hotel_rooms'],
    eventSteps: {
        personal_details: defaultSteps.personal_details
    },
    steps: {
        personal_details: defaultSteps.personal_details
    }
};

export default function (state = initialState, action) {

    const {payload, type} = action
    const activeStepName = state.activeStep[state.activeGuest];

    switch (type) {
        case LOAD_GUESTS:
            const index = (state.activeGuest === null || state.activeGuest < 0) ? payload.map((e) => e.main).indexOf(true) : state.activeGuest;
            const guests = payload.keys();

            let activeStepsState = {};
            let formData = {};

            for (const key of guests) {
                activeStepsState[key] = Boolean(state.activeStep[key]) ? state.activeStep[key] : 'personal_details';
                const guest = payload[key];

                formData[key] = guestFormData(guest);
            }

            return {
                ...state,
                list: payload,
                activeGuest: index >= 0 ? index : null,
                activeStep: activeStepsState,
                formData: formData,
                loaded: true
            };

        case UPDATE_GUEST:

            return produce(state, (draft) => {

                let ids = draft.list.map((guest) => guest.id);
                let index = ids.indexOf(payload.id);

                draft.list[index] = payload;
            });

        case SET_STEPS:

            return produce(state, (draft) => {
                Object.keys(payload).forEach((step) => {
                    if (payload[step]) {
                        draft.eventSteps[step] = defaultSteps[step];
                        draft.steps[step] = defaultSteps[step];
                    }
                });
            });

        case SET_ACTIVE_GUEST:

            return produce(state, (draft) => {
                draft.steps = {};
                const isMainGuest = state.list[payload].main

                Object.keys(state.eventSteps).forEach((step) => {
                    if (isMainGuest || (!isMainGuest && !state.subGuestExcludedSteps.includes(step))) {
                        draft.steps[step] = defaultSteps[step]; 
                    }
                });

                draft.activeGuest = payload;
            });

        case SET_ACTIVE_STEP:

            return produce(state, (draft) => {
                draft.activeStep[state.activeGuest] = payload;
            });

        case UPDATE_GUEST_FORM:

            return produce(state, (draft) => {
                draft.formData[state.activeGuest][activeStepName] = payload;
            });

        case ADD_GUEST_DOCUMENT:

            return produce(state, (draft) => {
                draft.list[state.activeGuest].documents.push(payload);
            });

        case REMOVE_GUEST_DOCUMENT:

            return produce(state, (draft) => {
                let ids = draft.list[state.activeGuest].documents.map((doc) => doc.id);
                let index = ids.indexOf(payload);
                draft.list[state.activeGuest].documents.splice(index, 1);
            });

        default:
            return state;
    }
}
